import { render, staticRenderFns } from "./RobotShare.vue?vue&type=template&id=a1dc1080&scoped=true"
import script from "./RobotShare.vue?vue&type=script&lang=js"
export * from "./RobotShare.vue?vue&type=script&lang=js"
import style0 from "./RobotShare.vue?vue&type=style&index=0&id=a1dc1080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1dc1080",
  null
  
)

export default component.exports